import { gql } from 'apollo-angular';
import { AdminUserFragments } from '../fragments/admin-user-fragments';
import { ADMIN_USER_PREFERENCE_FIELDS } from '../fragments/admin-user-preference-fragments';

export const AdminUserList = gql`
  query AdminUserList($input: AdminUsersSearchInput) {
    adminUsers(input: $input) {
      page
      itemsFound
      offset
      items {
        id
        email
        firstName
        middleName
        lastName
        job
        phone
        language
        createdAt
        lastModifiedAt
      }
    }
  }
`;

export const AdminUser = gql`
  query AdminUser($email: String!) {
    adminUser(email: $email) {
      ...adminUser
    }
  }
  ${AdminUserFragments.adminUser}
`;

/**
 * A single user's tenant grants, for the staff-only Tenant access panel.
 *
 * Must be sent with the admin-authentication tenant header: under a business
 * tenant header the backend scopes the lookup and a user who is not in that
 * tenant comes back as "User not found" — which is exactly the user this panel
 * exists to work on.
 *
 * `offset` is a PAGE SIZE on this input, not a skip.
 */
export const AdminUserTenantAccess = gql`
  query AdminUserTenantAccess($email: String!) {
    adminUser(email: $email) {
      id
      email
      tenants(input: { offset: 200 }) {
        items {
          id
          tenant
          name
          default
          tenantInfo {
            id
            name
          }
        }
      }
    }
  }
`;

export const AdminUserTenants = gql`
  query AdminUserTenants($email: String!) {
    adminUser(email: $email) {
      id
      email
      gender
      firstName
      middleName
      lastName
      language
      phone
      job
      createdAt
      lastModifiedAt
      tenants(input: { offset: 100 }) {
        items {
          id
          tenant
          name
          default
          tenantInfo {
            id
            name
            descriptions {
              language
              value
            }
            restrictSalesPricingVisibility
            allowQuoteInvalidation
            quoteDefaultExpiryPeriodDays
            defaultAppLanguage
            defaultDataLanguage
            priceDecimals
          }
        }
      }
      # NBO-2516: the user's GLOBAL preferences ride the login query, so login waits for no extra
      # request. This query runs under the admin-tenant header, where a read returns GLOBAL rows
      # only; the TENANT rows are read once the active tenant is known (PreferencesService).
      preferences(input: { offset: 100 }) {
        itemsFound
        items {
          ...AdminUserPreferenceFields
        }
      }
    }
  }
  ${ADMIN_USER_PREFERENCE_FIELDS}
`;
